import React, { Component } from "react";
import {
  Layout,
  Page,
  Card,
  List,
  TextField,
  Banner,
  TextStyle,
} from "@shopify/polaris";
import screenshot from "./../resources/screenshot.png";

class FAQ extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const primaryAction = {
      content: "Go Pro",
      onAction: () => {
        this.changePage("/pro");
      },
    };
    const secondaryActions = [
      {
        content: "Home",
        onAction: () => {
          this.changePage("/");
        },
      },
      {
        content: "FAQ",
        onAction: () => {
          this.changePage("/faq");
        },
      },
      {
        content: "Privacy Policy",
        onAction: () => {
          this.changePage("/terms");
        },
      },
    ];

    return (
      <Page
        title="FAQ"
        primaryAction={primaryAction}
        secondaryActions={secondaryActions}
      >
        <Banner status="critical">
          <TextStyle variation="strong">
            After much consideration, we have decided to sunset the app on the
            5th of October 2024. This app will cease to function on this date.
            We are currently creating a new app that will replace this one. And
            we will notify you once it is available. We apologize for any
            inconvenience this may cause.
          </TextStyle>
        </Banner>
        <div
          style={{
            paddingTop: 20,
          }}
        ></div>
        <Layout>
          <Layout.Section>
            <Card title="Frequently Asked Questions">
              <Card.Section title="Do you provide support?">
                <p>
                  We certainly do, please feel free to get in contact with us
                  via our email:
                  <br />
                  support@kiwisprout.nz
                </p>
              </Card.Section>
              <Card.Section title="Why isn't my free shipping rate showing in the checkout? How do I set up my free shipping rate?">
                <p>Please make sure you have followed these instructions:</p>
                <br />
                <List type="number">
                  <List.Item>
                    In your Shopify admin, click "Settings", then click
                    "Shipping".
                  </List.Item>
                  <List.Item>
                    Click "Edit" on the shipping zone where you want to offer
                    free shipping, or click "Add Shipping zone" if you have not
                    yet created a shipping rule for the area you want to offer
                    free shipping.
                  </List.Item>
                  <List.Item>
                    Make sure your shipping zone has the correct country &
                    regions set for where you want to offer free shipping.
                  </List.Item>
                  <List.Item>
                    In the panel "Price based rates" click the button "Add
                    rate", a dialog box should pop up.
                  </List.Item>
                  <List.Item>
                    In the dialog box, give your free shipping rate an
                    appropriate name, then set the field "Minimum order price"
                    to be the same as the cart goal you set within this app.
                  </List.Item>
                  <List.Item>
                    Check the checkbox "Free shipping rate" then click the
                    "Done" button, and finally click the "Save" button.
                  </List.Item>
                  <List.Item>
                    When done, don't forget to enable your goal bar.
                  </List.Item>
                </List>
              </Card.Section>
              <Card.Section title="Why can't I save my settings?">
                <p>
                  If your save button is disabled it is because the currency
                  code you put into "Default currency code" was not a recognized
                  currency code, if you need help finding your country's
                  currency code or if your currency code is correct and you
                  believe we have made a mistake please get in contact with us
                  via our email support@kiwisprout.nz and we will help you sort
                  it out.
                </p>
              </Card.Section>
              <Card.Section title="Why isn't my goal bar appearing?">
                <p>Please check the following:</p>
                <br />
                <List>
                  <List.Item>
                    That the goal bar is enabled and has been saved.
                  </List.Item>
                  <List.Item>
                    For pro users, please check that where you have selected the
                    goal bar to appear matches where you want the goal bar to
                    appear.
                  </List.Item>
                  <List.Item>
                    If you are confident the goal bar should be showing and is
                    not, please follow the instructions to manually install your
                    goal bar at the bottom of this page.
                  </List.Item>
                </List>
              </Card.Section>
              <Card.Section title="How do you automatically convert the goal value from my default currency into the visitor's local currency?">
                <p>
                  If you have ticked the option in the settings, when your
                  customer visits your website they're asked to share their
                  location, if they allow their location to be shared, we use
                  that to get back their local currency code and we use that
                  with Shopify's currency converter to convert your default
                  currency into the customer's local currency. If your customer
                  does not allow sharing their location, your default currency
                  will be used, we believe by asking for permission first before
                  accessing the customer's location we are respecting the
                  customer's right to privacy.
                </p>
              </Card.Section>
              <Card.Section title="Why aren't my changes being saved?">
                <p>
                  Make sure you are pressing the "Save" button after making your
                  changes, if that fails please try closing and reopening the
                  app, if the issue persists don't hesistate to get in touch via
                  our email support@kiwisprout.nz
                </p>
              </Card.Section>
              <Card.Section title="My goal bar doesn't look quite like the preview, why is that?">
                <p>
                  We try to create a consistent appearance across all forms of
                  media but it's still possible for the appearance to be
                  overridden. There could be a few reasons why the goal bar
                  doesn't look quite like what is shown in the preview, the most
                  common reasons are how your browser renders the goal bar, or
                  the styling rules of your store's theme.
                </p>
              </Card.Section>
              <Card.Section title="I accidentally reset my options that I wanted to keep, can I recover it?">
                <p>
                  After your options are reset, it cannot be recovered and is
                  permanently deleted.
                </p>
              </Card.Section>
              <Card.Section title="What browsers do you support?">
                <p>
                  We support the same browsers as Shopify, which includes the
                  latest versions of:
                </p>
                <br />
                <List>
                  <List.Item>Google Chrome</List.Item>
                  <List.Item>Mozilla Firefox</List.Item>
                  <List.Item>Apple Safari</List.Item>
                  <List.Item>Microsoft Edge</List.Item>
                  <List.Item>Opera</List.Item>
                  <List.Item>Apple Safari for IOS</List.Item>
                  <List.Item>Google Chrome for Android</List.Item>
                </List>
              </Card.Section>
              <Card.Section title="What screen size does 'disable on mobile' hide on?">
                <p>767 pixels and below.</p>
              </Card.Section>
              <Card.Section title="Do I need to make any code changes to my website after installing or uninstalling?">
                <p>
                  You should not have to make any changes to the website after
                  installing or uninstalling this app, we do not make any
                  changes to your theme's code.
                </p>
                <p>
                  Our app automatically adds your free shipping goal bar to the
                  page when it loads.
                </p>
              </Card.Section>
              <Card.Section title="How do I manually install my free shipping goal bar?">
                <p>
                  If you would like to manually install your free shipping goal
                  bar, please follow these instructions:
                </p>
                <br />
                <List type="number">
                  <List.Item>
                    In your Shopify admin, click "<b>Online Store</b>", it
                    should take you to the "<b>Themes</b>" page.
                  </List.Item>
                  <List.Item>
                    Then click the "<b>Actions</b>" dropdown button, and click "
                    <b>Edit code</b>", it should take you to your code editor.
                  </List.Item>
                  <List.Item>
                    Find the file <b>theme.liquid</b> in the left sidebar and
                    click on the file to open it.
                  </List.Item>
                  <List.Item>
                    In the file <b>theme.liquid</b>, find <b>&lt;body</b>
                  </List.Item>
                  <List.Item>
                    Copy <b>all</b> of the code in the text field at the bottom
                    of this FAQ page.
                  </List.Item>
                  <List.Item>
                    Paste the code in the line directly below <b>&lt;body</b> at
                    the very start of the line, it should look something like
                    this:
                  </List.Item>
                  <br />
                  <img
                    src={screenshot}
                    className="screenshot"
                    alt="instructions screenshot"
                  />
                  <br />
                  <List.Item>
                    Press the <b>save</b> button in the top right of the screen,
                    your free shipping goal bar is now manually installed.
                  </List.Item>
                  <List.Item>
                    If you have any questions or issues with these instructions,
                    please feel free to get in contact with us via our email:{" "}
                    <b>support@kiwisprout.nz</b>
                  </List.Item>
                </List>
                <br />
                <br />
                <TextField
                  value={
                    '<div id="fspb_wrapper"></div> <style type="text/css">.fspb-container{height:40px;position:fixed;max-width:600px;width:85%;background:#555;padding:0;box-shadow:inset 0 -1px 1px rgba(255,255,255,.3);display:flex;align-items:center;margin:20px;left:50%;transform:translateX(-50%);z-index:2147483647;transition:0.2s all;opacity:0;bottom:-40px}.fspb-container.fspb-show{opacity:1;bottom:0}.fspb-bar{display:block;height:100%;background-color:rgb(43,194,83);box-shadow:inset 0 2px 9px rgba(255,255,255,.3),inset 0 -2px 6px rgba(0,0,0,.4);position:relative;overflow:hidden;max-width:100%;transition:width 0.6s}.fspb-bar:after{content:"";position:absolute;top:0;left:0;bottom:0;right:0;background-image:linear-gradient(-45deg,rgba(255,255,255,.2) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.2) 50%,rgba(255,255,255,.2) 75%,transparent 75%,transparent);z-index:1;background-size:50px 50px;animation:fspb-move 2s linear infinite;overflow:hidden}.fspb-text{position:absolute;text-decoration:none;color:#fff;text-shadow:0 0 21px rgba(0,0,0,.5);width:100%;z-index:2147483647;text-align:center;font-weight:900;font-size:16px;font-family:Arial,Helvetica,sans-serif;letter-spacing:0;left:0;right:0}.fspb-text:hover{opacity:1!important;color:#fff!important;text-decoration:none!important;font-weight:900!important}.fspb-close{position:absolute;width:20px;height:20px;border-radius:15px;z-index:2147483647;right:-15px;top:-25px;background-color:#555;color:#fff;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 2px -2px rgba(0,0,0,.1)}.fspb-close:before,.fspb-close:after{position:absolute;content:" ";height:10px;width:2px;background-color:#FFF}.fspb-close:before{transform:rotate(45deg)}.fspb-close:after{transform:rotate(-45deg)}.fspb-container.fspb-edge{padding:5px}.fspb-container.fspb-rounded{border-radius:60px}.fspb-container.fspb-rounded>.fspb-bar{border-radius:60px}.fspb-container.fspb-full{bottom:0;width:100%;max-width:none;margin:0}.fspb-container.fspb-full .fspb-close{right:5px}@keyframes fspb-move{0%{background-position:0 0}100%{background-position:50px 50px}}.fspb-container.shopify-app-only{position:relative}@media (max-width:768px){.fspb-container{height:60px!important;margin:0!important;bottom:20px!important}.fspb-container.fspb-desktop-only{display:none!important}.fspb-text{font-size:14px}.fspb-container.shopify-app-only{margin-top:20px;margin-bottom:80px}}.fspb-orange{background-color:#f36d0a}.fspb-red{background-color:#f42323}.fspb-blue{background-color:#0a99f2}.fspb-green-blue{background-color:#7ee8fa;background-image:linear-gradient(315deg,#7ee8fa 0%,#80ff72 74%)}.fspb-pink-magenta{background-color:#861657;background-image:linear-gradient(326deg,#861657 0%,#ffa69e 74%)}.fspb-purple{background-color:#a4508b;background-image:linear-gradient(326deg,#a4508b 0%,#5f0a87 74%)}.fspb-brushed-steel{background-color:#bdd4e7;background-image:linear-gradient(315deg,#bdd4e7 0%,#8693ab 74%)}.fspb-carbon{background-color:#000;background-image:linear-gradient(315deg,#000000 0%,#414141 74%)}.fspb-midnight{background-color:#000;background-image:linear-gradient(147deg,#000000 0%,#2c3e50 74%)}.fspb-pastel{background-color:#eec0c6;background-image:linear-gradient(315deg,#eec0c6 0%,#7ee8fa 74%)}.fspb-salmon{background-color:#f9c1b1;background-image:linear-gradient(315deg,#f9c1b1 0%,#fb8085 74%)}.fspb-dream{background-color:#f8ceec;background-image:linear-gradient(315deg,#f8ceec 0%,#a88beb 74%)}.fspb-gum{background-color:#fad0c4;background-image:linear-gradient(315deg,#fad0c4 0%,#f1a7f1 74%)}.fspb-cream{background-color:#f9d29d;background-image:linear-gradient(315deg,#f9d29d 0%,#ffd8cb 74%)}.fspb-cloud{background-color:#e7eff9;background-image:linear-gradient(315deg,#e7eff9 0%,#cfd6e6 74%)}.fspb-sky{background-color:#63a4ff;background-image:linear-gradient(315deg,#63a4ff 0%,#83eaf1 74%)}.fspb-lake{background-color:#045de9;background-image:linear-gradient(315deg,#045de9 0%,#09c6f9 74%)}.fspb-egg{background-color:#f39f86;background-image:linear-gradient(315deg,#f39f86 0%,#f9d976 74%)}.fspb-mars{background-color:#f9484a;background-image:linear-gradient(315deg,#f9484a 0%,#fbd72b 74%)}.fspb-yolk{background-color:#fbb034;background-image:linear-gradient(315deg,#fbb034 0%,#ffdd00 74%)}.fspb-ruby{background-color:#900;background-image:linear-gradient(147deg,#990000 0%,#ff0000 74%)}.fspb-emerald{background-color:#00b712;background-image:linear-gradient(315deg,#00b712 0%,#5aff15 74%)}.fspb-jade{background-color:#7cffcb;background-image:linear-gradient(315deg,#7cffcb 0%,#74f2ce 74%)}.fspb-bronze{background-color:#772f1a;background-image:linear-gradient(315deg,#772f1a 0%,#f2a65a 74%)}</style>'
                  }
                  multiline
                  readOnly
                />
              </Card.Section>
            </Card>
          </Layout.Section>
        </Layout>
      </Page>
    );
  }

  // Change our page, but only if our current page is done loading to prevent memory leaks
  changePage = (url, keepParams = true) => {
    this.props.history.push(url + (keepParams ? window.location.search : ""));
  };

  valueUpdater(field) {
    return (value) => this.setState({ [field]: value });
  }
}

export default FAQ;
